import { render, staticRenderFns } from "./ApplicationsForm.vue?vue&type=template&id=dbdf4a78&scoped=true&"
import script from "./ApplicationsForm.vue?vue&type=script&lang=js&"
export * from "./ApplicationsForm.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationsForm.vue?vue&type=style&index=0&id=dbdf4a78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbdf4a78",
  null
  
)

export default component.exports